import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateProductReturn = {
  name: "updateProductReturn" as const,
  input: z.object({
    returnId: zExt.objectId(),
    productId: zExt.objectId(),
    newType: z
      .enum([
        "refund",
        "store_credit",
        "exchange_refund",
        "exchange_store_credit",
      ])
      .optional(),
    newValue: z.number().optional(),
    note: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
